import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=1fb7f6da"
import script from "./AccordionGroup.vue?vue&type=script&lang=ts"
export * from "./AccordionGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports